import { ReportService } from './../report.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxExtendedPdfViewerComponent, NgxExtendedPdfViewerService, ProgressBarEvent } from 'ngx-extended-pdf-viewer';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-load-report',
  templateUrl: './load-report.component.html',
  styleUrls: ['./load-report.component.scss']
})
export class LoadReportComponent implements OnInit {
  loadingMessage: string;// = "Even geduld, het pdf rapport wordt opgehaald uit de cloud...";
  loadingVisible: boolean = true;
  validHash: boolean = false;
  klantReferentie: any;
  fileContent: any;
  fileNameForDownload: string = "document.pdf";
  showError: boolean = false;
  @ViewChild(NgxExtendedPdfViewerComponent, { static: false }) pdfViewer!: NgxExtendedPdfViewerComponent;
  spreadMode: 'off' | 'even' | 'odd' = 'off';
  page: number;
  request: any;
  progresValue: number = 0;

  constructor(private reportService: ReportService, private route: ActivatedRoute, private pdfViewerService: NgxExtendedPdfViewerService,
    private _translateService: TranslateService
  ) {
    this.loadingMessage = _translateService.instant('RAPPORT.VIEWER.MELDING.LADEN');
  }

  ngOnInit(): void {
    const hash = this.route.snapshot.paramMap.get('hash');
    if (!!hash) {

      this.reportService.downloadReportByHash(hash).subscribe({
        next: data => {
          this.validHash = true;
          this.fileNameForDownload = data.FileName;
          this.fileContent = data.TemporaryAzureUrl;
          this.klantReferentie = data.ReportTitle;
        },
        error: error => {
          this.loadingVisible = false;
          this.validHash = false;
          this.fileContent = null;
          this.fileNameForDownload = null;
        }
      });
    } else {
      this.loadingVisible = false;
      this.validHash = false;
    }
  }

  onPageRendered(): void {
    if (!this.pdfViewerService.isRenderQueueEmpty()) {
      // try again later when the pages requested by the pdf.js core or the user have been rendered
      setTimeout(() => this.onPageRendered(), 100);
    }

    if (this.loadingVisible) this.loadingVisible = false;

    const pagesBefore = this.spreadMode === 'off' ? 2 : 2;
    const pagesAfter = this.spreadMode === 'off' ? 2 : 5;
    let startPage = Math.max(this.page - pagesBefore, 1);
    let endPage = Math.min(this.page + pagesAfter, this.pdfViewerService.numberOfPages());

    const renderedPages = this.pdfViewerService.currentlyRenderedPages();

    for (let page = startPage; page <= endPage; page++) {
      const pageIndex = page - 1;
      if (!this.pdfViewerService.hasPageBeenRendered(pageIndex)) {
        this.pdfViewerService.addPageToRenderQueue(pageIndex);
        break; // break because you can request only one page at a time
      }
    }
  }

  formatStatus(ratio, value) {
    return 'Downloaden: ' + Math.round(ratio * 100) + '%'
  }

  onProgress(event: ProgressBarEvent): void {
    this.progresValue = event.percent;
  }

  pdfLoaded(event) {
    this.progresValue = 0;
    this.loadingMessage = this._translateService.instant('RAPPORT.VIEWER.MELDING.OPENEN');
  }
}
